module.exports = __webpack_public_path__ + "img/scarlet devil tower princess.299b8a6e.png";